import { createApi } from "@reduxjs/toolkit/query/react";
import { mapDashboardFilter } from "@/redux/mappers/Export/CreateNewJob/generalMapper";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importdashboardfilterApi = createApi({
  reducerPath: "importdashboardfilterApi",
  baseQuery,
  tagTypes: ["Dashboard"], // ✅ required if using providesTags or invalidatesTags
  endpoints: (builder) => ({
    // Fetch Dashboard table data with filters
    getDashboard: builder.query({
      query: (filters) => ({
        url: apiurl.Import_filter, 
        method: "POST",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: mapDashboardFilter(filters),
      }),
      transformResponse: (response) => response?.data || [],
      providesTags: ["Dashboard"],
    }),

    // Optional: if you want a mutation to apply filters (rare for GET)
    applyimportDashboardFilter: builder.mutation({
      query: (filters) => {
        const body = filters;
    
        return {
          url: apiurl.Import_filter,
          method: "POST",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: body,
        };
      },
      invalidatesTags: ["Dashboard"], // ✅ make sure this is defined
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetDashboardQuery,
  useApplyimportDashboardFilterMutation,
} = importdashboardfilterApi;
